module.exports = __webpack_public_path__ + "static/ultroloth-4651c91130ec53bc98c6058d08d6bf75.jpeg";